import React from 'react';

const WhatIveDone = () => (
  <div className="about-container">
    <div className="about-text">
      <h2>What I've Done</h2>
      <p>
        As a <strong>reporter</strong>, I built environment and energy beats at two public radio stations: West Virginia Public Broadcasting and Louisville Public Media. In two places where the 
        energy sector and economy were reliant on coal, my years of reporting revealed the real-world effects of lawmakers' inaction on coalfield residents. More recently, I have done data-driven 
        investigations into West Virginia’s child welfare system for Mountain State Spotlight.
      </p>
      <p>
        As an <strong>editor</strong>, I have worked with students, staff reporters, and freelancers from concept to publication on everything from spot news to podcasts to investigations.
      </p>
      <p>
        As a <strong>newsroom leader</strong>, I led the large local, regional and investigative team at 
        Louisville Public Media. During my time as Director of News and Programming, my team launched a weekly show, created multiple award-winning podcasts and catapulted 
        ourselves into becoming a main source of news for local residents through our coverage of a historic pandemic and racial justice protests. Later, at Mountain State Spotlight 
        in West Virginia, I built an audience and membership program from the ground up, crafted coverage plans, launched new products and managed the reporting staff.
      </p>
      <p>
        <strong>Currently</strong>, I’m wearing lots of hats. I am the Fellowships Manager for Cincinnati Public Radio, where I’ve created an early-career fellowship and am training, managing 
        and mentoring the fellows. I’m an editor-at-large for Mountain State Spotlight, where I’ve done my own investigations into the state’s foster care system. I edit for public media 
        stations around the country as part of the Public Media Journalists Association Editor Corps, and am the digital managing editor for 100 Days in Appalachia. I’m also a contract 
        editor for Future Today Strategy Group, working to make sure their publications are clear, accurate, and accessible to readers around the world.
      </p>
      <p>
        In 2026, I’m also continuing my work creating more comprehensive voter guides with newsrooms around the country.
      </p>
      <p>
        I live outside Louisville, Kentucky with my husband and two sons.
      </p>
      <p>
        <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" className="btn">
          Click here for my resume
        </a>
      </p>
    </div>
  </div>
);

export default WhatIveDone;